import React from 'react'
import HeroBanner from '../component/HeroBanner'
import HomeAbout from '../component/HomeAbout'
import HomeServices from '../component/HomeServices'
import Feature from '../component/Feature'
import AppScreen from '../component/AppScreen'
import Faq from '../component/Faq'

export default function Home() {
    return (
        <>
            <HeroBanner />
            <HomeAbout />
            <HomeServices />
            <Feature />
            <AppScreen />
            <div className='container'>
                <Faq />
            </div>
        </>
    )
}
